import axios from "axios";
import {
  DoctorPatient,
  CreateDoctorPatientPayload,
  PaginatedPatientResponse,
} from "../types/patient";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:8000/api/v1";

const api = axios.create({ baseURL: BASE_URL });

// Inject auth token on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const patientService = {
  /** List doctor-scoped patients with optional search and pagination */
  fetchDoctorPatients: async (params?: {
    search?: string;
    page?: number;
    page_size?: number;
  }): Promise<PaginatedPatientResponse> => {
    const response = await api.get<PaginatedPatientResponse>(
      "/doctor/patients/",
      { params }
    );
    return response.data;
  },

  /** Fetch a single doctor-scoped patient */
  fetchDoctorPatient: async (patientId: number): Promise<DoctorPatient> => {
    const response = await api.get<DoctorPatient>(
      `/doctor/patients/${patientId}/`
    );
    return response.data;
  },

  /** Create a patient scoped to the authenticated doctor */
  createDoctorPatient: async (
    payload: CreateDoctorPatientPayload
  ): Promise<DoctorPatient> => {
    const response = await api.post<DoctorPatient>("/doctor/patients/", payload);
    return response.data;
  },

  /** Update a doctor-scoped patient */
  updateDoctorPatient: async (
    patientId: number,
    payload: Partial<CreateDoctorPatientPayload>
  ): Promise<DoctorPatient> => {
    const response = await api.patch<DoctorPatient>(
      `/doctor/patients/${patientId}/`,
      payload
    );
    return response.data;
  },

  /** Delete a doctor-scoped patient */
  deleteDoctorPatient: async (patientId: number): Promise<void> => {
    await api.delete(`/doctor/patients/${patientId}/`);
  },
};

export default patientService;
